import { STORAGE_KEY } from '@/constant/constant';
import { getCookie, setCookie } from '@/utils/cookie';
import { getLocal, setLocal } from '@/utils/storage';
// import { formMonitorSlsLog } from '@/service/formMonitorSlsLog';
import { companyUUID, getShopifyUserId } from '@/service/api';

interface CookieMessage {
  type: 'COOKIE_RESPONSE' | 'GET_COOKIE';
  payload?: {
    oneId?: string;
    companyUuid?: string;
    shopifyUserId?: string | null;
  };
}

const ONEID_ORIGIN = 'https://d39va5bdt61idd.cloudfront.net';

export function getOneId(): void {
  // 添加消息处理器之前先移除旧的，避免重复监听
  const messageHandler = function (event: MessageEvent<CookieMessage>) {
    // 严格检查来源域名
    if (event.origin !== ONEID_ORIGIN) {
      // 只有当消息看起来像是尝试模仿我们的协议时才记录
      if (event.data && (event.data.type === "COOKIE_RESPONSE" || event.data.type === "GET_COOKIE")) {
        console.warn('收到可疑来源消息:', event.origin);
        // formMonitorSlsLog({ type: 'oneid_suspicious_origin', origin: event.origin });
      }
      return;
    }

    // 检查消息格式
    if (!event.data || event.data.type !== "COOKIE_RESPONSE") {
      // formMonitorSlsLog({ type: 'oneid_invalid_message_format', data: event.data });
      return;
    }

    const oneId = event.data.payload?.oneId;
    console.log('接收到oneId:', oneId); // 添加调试日志
    // formMonitorSlsLog({ type: 'oneid_received_oneid', oneId: oneId });

    if (!oneId) {
      console.warn('接收到空的oneId');
      // formMonitorSlsLog({ type: 'oneid_empty_oneid' });
      return;
    }

    try {
      // 跨域 iframe 回传的 oneId 同时写 cookie 与 local，供主站读取
      setCookie(STORAGE_KEY.ONE_ID, oneId);
      setLocal(STORAGE_KEY.ONE_ID, oneId);
      console.log('成功存储oneId'); // 添加调试日志
      // formMonitorSlsLog({ type: 'oneid_storage_success', oneId: oneId });
      window?.postMessage('_cartsee_send');
    } catch (e) {
      console.error('存储数据失败:', e);
      // formMonitorSlsLog({ type: 'oneid_storage_failure', error: e });
    }
  };

  // 移除可能存在的旧监听器
  window.removeEventListener('message', messageHandler);
  window.addEventListener('message', messageHandler);

  // 修改：添加额外的安全属性
  const iframe = document.createElement('iframe');
  iframe.id = 'cookieReader';
  // iframe.src = 'https://image.cartx.cloud/cartsee-one/index.html';
  iframe.src = `${ONEID_ORIGIN}/onsite/index.html`;
  // 基础样式设置
  iframe.style.cssText = 'display:none; width:0; height:0; border:0; position:absolute;';
  // 只保留关键的安全属性
  iframe.setAttribute('crossorigin', 'use-credentials');
  iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms');
  document.body.appendChild(iframe);

  // 添加错误处理
  iframe.onerror = function (error: Event | string) {
    console.error('iframe 加载失败:', error);
    // formMonitorSlsLog({ type: 'oneid_iframe_load_failure', error: String(error) });
  };

  // 等待iframe加载完成后再发送消息
  iframe.onload = function () {
    // console.log('iframe 加载完成，当前域名:', window.location.origin);
    // formMonitorSlsLog({ type: 'oneid_iframe_load_success' });
    iframe.contentWindow.postMessage({
      type: 'GET_COOKIE',
      payload: {
        companyUuid: companyUUID,
        shopifyUserId: getShopifyUserId()
      }
    }, '*');
  };
}

export function oneidInit(): void {
  const oneId = getCookie(STORAGE_KEY.ONE_ID) || getLocal(STORAGE_KEY.ONE_ID);
  // console.log('oneId:', oneId);
  if (!oneId) {
    getOneId();
  }
}
